import { FunctionComponent } from "react";
import classnames from "classnames";

import { AlertType } from "@ppb/the-wall-common/types";
import { InlinePanelColorMap, InlinePanelColor } from "../../../InlinePanel/InlinePanel.types";
import { NudgesNumberInputField, FreeBets, SecondaryButton, PrimaryButton, Alert } from "@ppb/the-wall-web";
import { PNLAndWhatIf } from "../../../PNLAndWhatIf/PNLAndWhatIf.web";
import { PNLAndWhatIfSize } from "../../../PNLAndWhatIf/PNLAndWhatIf.types";
import { OutcomeBetSegments } from "../../../OutcomeBetSegments/OutcomeBetSegments.web";
import { BetSegmentsSize } from "../../../BetSegments/BetSegments.types";
import { BspOddsLimit } from "../../../BspOddsLimit/BspOddsLimit.web";
import { InlinePanel } from "../../../InlinePanel/InlinePanel.web";
import { ExchangeJurisdictionalOperatorInfo } from "../../../JurisdictionalOperatorInfo/JurisdictionalOperatorInfo.web";
import type { ExchangeInlineConfirmPanelViewModel } from "./ExchangeInlineConfirmPanel.types";
import styles from "./ExchangeInlineConfirmPanel.web.css";

const noop = () => {};

export const ExchangeInlineConfirmPanel: FunctionComponent<ExchangeInlineConfirmPanelViewModel> = ({
  labels,
  confirm,
  loading,
  title,
  titlePrefix,
  freeBets,
  side,
  price,
  size,
  currencySymbol,
  matchMePrefix,
  multiplier,
  profitLabel,
  profitValue,
  profitRawValue,
  betDelay,
  error,
  isFreeBetsSelected,
  outcomeSegments,
  isSpActive,
  isOddsLimitActive,
  isLineBettingType,
  onCancel,
  onEdit,
  onConfirm,
}) => (
  <div className={styles.container}>
    <InlinePanel
      title={title}
      titlePrefix={titlePrefix}
      color={isLineBettingType ? InlinePanelColor.Green : InlinePanelColorMap[side]}
      onAction={onCancel}
    >
      <div className={classnames(styles.content, styles.inputFields)}>
        <NudgesNumberInputField
          readonly
          value={price}
          label={labels.price}
          multiplier={matchMePrefix}
          onChange={noop}
          onFocus={noop}
        />
        <NudgesNumberInputField
          readonly
          value={size}
          label={labels.size}
          currencySymbol={currencySymbol}
          multiplier={multiplier}
          onChange={noop}
          onFocus={noop}
        />
      </div>
      {outcomeSegments && (
        <div className={styles.outcomeSegments}>
          <OutcomeBetSegments {...outcomeSegments} size={BetSegmentsSize.LARGE} />
        </div>
      )}
      {isSpActive && (
        <div className={styles.freeBets}>
          <BspOddsLimit disabled isSelected={isOddsLimitActive} title={labels.oddsLimitTitle} />
        </div>
      )}
      {isFreeBetsSelected && (
        <div className={styles.freeBets}>
          <FreeBets isReadOnly label={freeBets} isSelected />
        </div>
      )}
      {error && (
        <div className={styles.alert}>
          <Alert type={AlertType.Error} message={error.message} detail={error.detail} />
        </div>
      )}
      <div className={styles.content}>
        <SecondaryButton label={labels.edit} onTap={onEdit} />
        <PrimaryButton
          label={confirm}
          secondaryLabel={profitLabel}
          delay={betDelay}
          loadingLabel={loading}
          stopAnimation={!!error}
          onTap={onConfirm}
        >
          <PNLAndWhatIf pnl={profitValue} rawPnl={profitRawValue} size={PNLAndWhatIfSize.MEDIUM} agnostic={true} />
        </PrimaryButton>
      </div>
      <div className={styles.operatorInfo}>
        <ExchangeJurisdictionalOperatorInfo />
      </div>
    </InlinePanel>
  </div>
);
